import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import colors from "../assets/styles/colour";

import Home from "../pages/Home";
import Login from "../pages/Login";
import Layout from "../components/Layout";
import MyAccount from "../pages/MyAccount";
import VerifyOTP from "../components/VerifyOtp";
import PanchayathList from "../pages/PanchayathList";
import AssemblyList from "../pages/AssemblyList";
import BoothList from "../pages/BoothList";
import VotersList from "../pages/VotersList";
import PanchayatDetails from "../pages/PanchayatDetails";
import BoothDetails from "../pages/BoothDetails";
import AssemblyDetails from "../pages/AssemblyDetails";
import AddVoters from "../pages/AddVoters";
import Constituency from "../components/Constituency";
import ConstituencyDetails from "../pages/ConstituencyDetails";
import ConstituencyList from "../pages/ConstituencyList";
import ManageUser from "../pages/ManageUser";
import SendMessage from "../pages/SendMessage";
import SurveyForm from "../components/SurveyForm";
import FormBuilder from "../components/FormBuilder";
import FormLists from "../pages/FormLists";
import SurveyFormData from "../pages/SurveyFormData";
import SurveyListById from "../pages/SurveyListById";
import Grivence from "../pages/Grivence";
import GrivenceList from "../pages/GrivenceList";
import AssemblyGreivance from "../pages/AssemblyGreivanceList";
import PanchayatGreivnaceList from "../pages/PanchayatGreivnaceList";
import AssemblyGreivanceList from "../pages/AssemblyGreivanceList";
import ConstituencyGreivanceList from "../pages/ConstituencyGreivanceList";
import AdminGrievanceList from "../pages/AdminGrievanceList";
import ElectionDetailsUpload from "../pages/ElectionDetailsUpload";
import EntryPage from "../website/EntryPage";
import BoothGreivanceList from "../pages/BoothGreivanceList";
import PastAnalysis from "../pages/PastAnalysis";
import ConstituencyElectionDetails from "../pages/ConstituencyElectionDetails";
import AssemblyElectionDetails from "../pages/AssemblyElectionDetails";
import AssemblyBriefDetails from "../pages/AssemblyBriefDetails";
import ConstituencyBriefDetails from "../pages/ConstituencyBriefDetails";
import AssemlbyElectionDetailsPage from "../pages/AssemlbyElectionDetailsPage";
import AlbumList from "../components/gallery/AlbumList";
import PhotoDetails from "../components/gallery/PhotoDetails";
import PhotoGallery from "../components/gallery/PhotoGallery";
import AppointmentLogin from "../appointment/AppointmentLogin";
import AppointmentForm from "../appointment/ApointmentForm";
import EventEntryPage from "../event-planner/EventEntryPage";
import AdminAppointment from "../admin-appointment/AdminAppointment";
import AdminAppointmentDetails from "../admin-appointment/AdminAppointmentDetails";
import AssemblyGraphDetails from "../components/graphs/AssemblyGraphDetails";
import PanchayatGraphDetails from "../components/graphs/PanchayatGraphDetails";
import BhoothGraphDetails from "../components/graphs/BhoothGraphDetails";
import AdminElectionDetails from "../pages/AdminElectionDetails";
import AllLevelBriefDetails from "../components/AllLevelBriefDetails";
import AllLevelElectionPage from "../components/AllLevelElectionPage";
import TodaysEvents from "../components/TodaysEvents";
import PageNotFound from "../components/PageNotFound";
import AboutElectionsUpload from "../components/aboutElections/AboutElectionsUpload";
import AboutConstituency from "../components/aboutElections/AboutConstituency";
import AboutAssembly from "../components/aboutElections/AboutAssembly";
import CreateAlbum from "../components/gallery/CreateAlbum";
import NewEntryPage from "../website-instance/EntryPage";
import CommonGrievance from "../website/components/CommonGrievance";
import TransportDetails from "../website-instance/travel/addVehicle";
import VehicleManagement from "../website-instance/travel/Vehicle";
import DriverManagement from "../website-instance/travel/ManageDrivers";
import TripManagement from "../website-instance/travel/Tripmanagement";
import AddTrip from "../website-instance/travel/AddTrip";
import DriverRegistration from "../website-instance/travel/DriverRegistration";
import VehicleDetails from "../website-instance/travel/VehicleDetails";
import DriverDetails from "../website-instance/travel/DriverDetaills";
import TripDetails from "../website-instance/travel/TripDetails";
import ExpensesTab from "../website-instance/travel/expenseTab";
import ResetPassword from "../pages/ResetPassword";
import AssetManagement from "../pages/AssetManagement";
import EmployeeManagement from "../pages/EmployeeManagement";
import FeedbackManagement from "../pages/FeedbackManagement";
import ForgotPassword from "../pages/ForgotPassword";
import VerifyPasswordOTP from "../pages/verifyOtp";



function Routing() {
  return (
    <Suspense>
      <Routes>
        {/* Public Route */}
        {/* <Route path="/" element={<EntryPage />} /> */}
        <Route path="/" element={<NewEntryPage />} />
        <Route path="signin" element={<Login />} />
        <Route path="appointment" element={<AppointmentLogin />} />
        <Route path="appointment-form" element={<AppointmentForm />} />
        <Route path="feedback" element={<FeedbackManagement />} />

        <Route path="verify-otp" element={<VerifyOTP />} />
        <Route path="survey" element={<SurveyForm />} />
        <Route path="survey-form/:id" element={<SurveyFormData />} />
         <Route path="forgot-password" element={<ForgotPassword />} />
           <Route path="verify-password-otp" element={<VerifyPasswordOTP />} />
           <Route path="/reset-password" element={<ResetPassword />} />

        {/* Private Routes */}
        <Route path="/login" element={<PrivateRoute />}>
          <Route path="" element={<Layout />}>
            <Route path="dashboard" element={<Home />} />
            <Route path="account" element={<MyAccount />} />
            <Route path="panchayat" element={<PanchayathList />} />
            <Route path="assembly" element={<AssemblyList />} />
            <Route path="booth" element={<BoothList />} />
            <Route path="add-voters" element={<AddVoters />} />
            <Route path="voters" element={<VotersList />} />
            <Route path="constituency" element={<ConstituencyList />} />
            <Route path="create-survey" element={<FormBuilder />} />
            <Route path="survey-lists" element={<FormLists />} />
            <Route path="list-of-surveys/:id" element={<SurveyListById />} />
            <Route path="grievance" element={<Grivence />} />
            <Route path="grievance-to-office" element={<Grivence />} />
            <Route path="grievance-list" element={<GrivenceList />} />
            <Route path="all-grievance" element={<AdminGrievanceList />} />
           

            <Route
              path="grievance-type/:status"
              element={<CommonGrievance />}
            />
            {/* <Route
              path="solved-grievance"
              element={<AssemblySolvedGrievance />}
            />
            <Route
              path="pending-grievance"
              element={<AssemblyPendingGrievance />}
            />
            \{" "}
            <Route
              path="rejected-grievance"
              element={<AssemblyRejectedGrievance />}
            /> */}
            <Route path="past-analysis" element={<PastAnalysis />} />
            <Route
              path="election-details"
              element={<ElectionDetailsUpload />}
            />
            <Route
              path="panchayat-grievance"
              element={<PanchayatGreivnaceList />}
            />
            <Route
              path="assembly-grievance"
              element={<AssemblyGreivanceList />}
            />
            <Route path="booth-grievance" element={<BoothGreivanceList />} />
            <Route
              path="constituency-grievance"
              element={<ConstituencyGreivanceList />}
            />
            <Route
              path="constituency-details"
              element={<ConstituencyDetails />}
            />
            <Route path="panchayat-details" element={<PanchayatDetails />} />
            <Route path="booth-details" element={<BoothDetails />} />
            <Route path="assembly-details" element={<AssemblyDetails />} />
            <Route
              path="assembly-election-details"
              element={<AssemblyElectionDetails />}
            />
            <Route
              path="admin-election-details"
              element={<AdminElectionDetails />}
            />
            <Route
              path="parliament-election-details"
              element={<ConstituencyElectionDetails />}
            />
            <Route
              path="all-level-brief-details"
              element={<AllLevelBriefDetails />}
            />
            <Route
              path="all-level-election-page"
              element={<AllLevelElectionPage />}
            />
            <Route
              path="parliament-brief-details"
              element={<ConstituencyBriefDetails />}
            />
            <Route path="manage-user" element={<ManageUser />} />
            <Route path="TransportDetails" element={<TransportDetails />} />
            <Route path="vehicle-management" element={<VehicleManagement />} />
            <Route path="DriverRegistration" element={<DriverRegistration />} />
            <Route path="VehicleDetaills" element={<VehicleDetails />} /> 
            <Route path="DriverDetails" element={<DriverDetails />} /> 
            <Route path="driver-management" element={<DriverManagement />} />
            <Route path="trip-management" element={<TripManagement />} />
            <Route path="trip-details" element={<TripDetails />} />
            <Route path="add-trip" element={<AddTrip />} />
            <Route path="ExpensesTab" element={<ExpensesTab />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="asset-management" element={<AssetManagement />} />
            <Route path="employee-management" element={<EmployeeManagement />} />
            <Route path="feedback" element={<FeedbackManagement />} />
            <Route path="send-message" element={<SendMessage />} />
            <Route path="send-message" element={<SendMessage />} />
            <Route path="assembly-gallery" element={<AlbumList />} />
            <Route path="constituency-gallery" element={<AlbumList />} />
            <Route path="panchayat-gallery" element={<AlbumList />} />
            <Route path="booth-gallery" element={<AlbumList />} />
            <Route path="albums/:id" element={<PhotoGallery />} />
            <Route
              path="albums/:id/photos/:photoIndex"
              element={<PhotoDetails />}
            />
            <Route path="albums/create" element={<CreateAlbum />} />
            <Route path="event-planner" element={<EventEntryPage />} />
            <Route path="admin-appointment" element={<AdminAppointment />} />
            <Route
              path="appointment-details"
              element={<AdminAppointmentDetails />}
            />
            <Route
              path="assembly-graph-details/:id"
              element={<AssemblyGraphDetails />}
            />
            <Route
              path="panchayat-graph-details/:id"
              element={<PanchayatGraphDetails />}
            />{" "}
            <Route
              path="bhooth-graph-details/:id"
              element={<BhoothGraphDetails />}
            />
            <Route path="todays-events" element={<TodaysEvents />} />
            <Route path="about-constituency" element={<AboutConstituency />} />
            <Route path="about-assembly" element={<AboutAssembly />} />
            <Route path="*" element={<PageNotFound />} />
          </Route>
        </Route>

        {/* Fallback Route */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Suspense>
  );
}

export default Routing;
